export function convertToFilename(value: string): string {
    return value.replace(/ /g, '_').replace(/\W/g, '');
}
